
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.4301 2.3C10.0501 1.71 7.75011 2.03 5.80011 2.94C5.45011 3.1 5.39011 3.58 5.70011 3.8C8.30011 5.6 10.0001 8.6 10.0001 12C10.0001 15.4 8.30011 18.4 5.70011 20.2C5.38011 20.42 5.44011 20.9 5.79011 21.06C7.07011 21.66 8.50011 22 10.0001 22C16.0501 22 20.8501 16.62 19.8701 10.4C19.2601 6.48 16.2801 3.24 12.4301 2.3Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-brightness-2`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBrightness2

    ```js
    <b-new-b-icon-brightness-2 />
    ```
</docs>


